<template>
	<div>
		<div class="sense-main">
			<div class="sense-breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				    <el-breadcrumb-item :to="{ path: '/order' }">{{orderNo}}</el-breadcrumb-item>
				    <el-breadcrumb-item>订单详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>			
			<div class="sense-table-list sense-table-ellipsis sense-detail">
				<div class="sense-detail-block">
					<h3>概要</h3>					
					<el-form label-width="110px">
						<el-row>
							<el-col :span="8">
								<el-form-item label="订单编号：">
									<div class="sense-text">{{ orderDetailObj.orderNo }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="8">
								<el-form-item label="产生原因：">
									<div class="sense-text">{{ orderDetailObj.reason | reasonFilter }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="8">
								<el-form-item label="订单状态：">
									<div class="sense-text">{{ orderDetailObj.status | statusFilter }}</div>
								</el-form-item>		
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<el-form-item label="创建时间：">
									<div class="sense-text">{{ orderDetailObj.createAt }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="8">
								<el-form-item label="支付时间：">
									<div class="sense-text">{{ orderDetailObj.payAt }}</div>
								</el-form-item>		
							</el-col>
						</el-row>								
					</el-form>					
				</div>
				<div class="sense-detail-block">
					<h3>产品信息</h3>					
					<el-form label-width="110px">
						<el-row>
							<el-col :span="8">
								<el-form-item label="产品分类：">
									<div class="sense-text">{{ orderDetailObj.categoryNo | categoryNoFilter }}</div>
								</el-form-item>
								<el-form-item label="产品名称：">
									<div class="sense-text">{{ orderDetailObj.productName }}</div>
								</el-form-item>
								<el-form-item label="数量：">
									<div class="sense-text">{{ orderDetailObj.buyCount }}</div>
								</el-form-item>
								<el-form-item label="价格：">
									<div class="sense-text">{{ orderDetailObj.price }}</div>
								</el-form-item>	
							</el-col>
							<el-col :span="8" v-if="orderDetailObj.productInfo">								
								<el-form-item label="许可形式：" v-if="orderDetailObj.categoryNo == 1">
									<div class="sense-text">{{ orderDetailObj.productInfo.licenseForm | licenseFormFilter }}</div>						
								</el-form-item>	
								
								<el-form-item label="许可周期：" v-if="orderDetailObj.categoryNo == 1">
									<div class="sense-text">{{ orderDetailObj.productInfo.licensePeriod | licensePeriodFilter(orderDetailObj.productInfo.isForever) }}</div>
								</el-form-item>		
								<el-form-item label="使用计数：" v-if="orderDetailObj.productInfo.licenseForm==1">
									<div class="sense-text">{{ orderDetailObj.productInfo.useCount?orderDetailObj.productInfo.useCount:'--' }}</div>		
								</el-form-item>
								<el-form-item label="许可类型：" v-if="orderDetailObj.productInfo.licenseForm==2 && orderDetailObj.productInfo.platform == 7">
									<div class="sense-text">{{ orderDetailObj.productInfo.hasConcurrent | concurrentFilter(orderDetailObj.productInfo.concurrentType, orderDetailObj.productInfo.concurrent) }}</div>		
								</el-form-item>	
								<el-form-item label="同时绑定数：" v-if="orderDetailObj.productInfo.licenseForm==2 && ((orderDetailObj.productInfo.platform == 7 && orderDetailObj.productInfo.hasConcurrent==false) || (orderDetailObj.productInfo.platform & 24) > 0)">
									<div class="sense-text">{{ orderDetailObj.productInfo.bindLimit }}</div>		
								</el-form-item>		
								<el-form-item label="累积绑定数：" v-if="orderDetailObj.productInfo.licenseForm==2 && orderDetailObj.productInfo.hasConcurrent==false && orderDetailObj.productInfo.platform == 7">
									<div class="sense-text">{{ orderDetailObj.productInfo.maxBound }}</div>			
								</el-form-item>		
							</el-col>
							<el-col :span="8" v-if="orderDetailObj.productInfo">
								<el-form-item label="系统平台：" v-if="orderDetailObj.categoryNo == 1 && orderDetailObj.productInfo.licenseForm==2">
									<div class="sense-text" v-if="orderDetailObj.productInfo.platform == 7" style="position: relative;top: -2px;">
										传统 (
										<em title="Windows" class="ssicon ss-windows"></em>
										<em title="Linux" class="ssicon ss-linux"></em>
										<em title="Mac" class="ssicon ss-mac"></em>
										)
									</div>
									<div class="sense-text" v-if="(orderDetailObj.productInfo.platform & 24) > 0" style="position: relative;top: -2px;">
										智能(
										<em title="Android" class="ssicon ss-android"></em>
										<em title="ARM Linux" class="arm-linux-icon"></em>
										)
									</div>							
								</el-form-item>	
								<el-form-item label="许可数量：" v-if="orderDetailObj.categoryNo == 1">
									<div class="sense-text">{{ orderDetailObj.productInfo.licenseCount | commonFilter(orderDetailObj.productInfo.hasLicenseCount) }}</div>		
								</el-form-item>
								<el-form-item label="更新次数：" v-if="orderDetailObj.categoryNo == 2">
									<div class="sense-text">{{ orderDetailObj.productInfo.updateCount | commonFilter(orderDetailObj.productInfo.hasUpdateCount) }}</div>		
								</el-form-item>
								<el-form-item label="计费方式：" v-if="orderDetailObj.categoryNo == 3">
									<div class="sense-text">{{ orderDetailObj.productInfo.chargeMode | chargeModeFilter }}</div>		
								</el-form-item>
								<el-form-item label="升级次数：" v-if="orderDetailObj.categoryNo == 3 && orderDetailObj.productInfo.chargeMode == 1">
									<div class="sense-text">{{ orderDetailObj.productInfo.upgradeCount }}</div>		
								</el-form-item>
								<el-form-item label="硬件锁数量：" v-if="orderDetailObj.categoryNo == 3 && orderDetailObj.productInfo.chargeMode == 2">
									<div class="sense-text">{{ orderDetailObj.productInfo.dongleCount }}</div>		
								</el-form-item>
								<el-form-item label="硬件锁周期：" v-if="orderDetailObj.categoryNo == 3 && orderDetailObj.productInfo.chargeMode == 2">		
									<div class="sense-text">{{ orderDetailObj.productInfo.donglePeriod | donglePeriodFilter }}</div>
								</el-form-item>
								<el-form-item label="套餐有效期：">
									<div class="sense-text">{{ orderDetailObj.productInfo.packagePeriod | packagePeriodFilter }}</div>
								</el-form-item>	
								<el-form-item label="套餐失效日期：">
									<div class="sense-text">{{ orderDetailObj.productInfo.expireTime | expireTimeFilter }}</div>
								</el-form-item>
							</el-col>
						</el-row>								
					</el-form>					
				</div>
				<div class="sense-detail-block">
					<h3>结算信息</h3>					
					<el-form label-width="110px">						
						<el-row>
							<el-col :span="8">
								<el-form-item label="应付金额：">
									<div class="sense-text">{{ orderDetailObj.amount }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="8">
								<el-form-item label="实付金额：">
									<div class="sense-text">{{ orderDetailObj.deductAmount }}</div>
								</el-form-item>		
							</el-col>
						</el-row>								
					</el-form>					
				</div>
			</div>
		</div>
		<div class="all-dialog">
			
		</div>
	</div>
</template>

<script>
	import { ajax } from '../api/api.js'

	export default {
		data() {
			return {
				orderNo: '',
				orderDetailObj: {},	
			}
		},
		filters: {
			//许可形式filter
			licenseFormFilter: function(val) {
				if (val == 1) {
					return '云锁';
				} else {
					return '软锁';
				};
			},
			//许可周期filter
			licensePeriodFilter: function(licensePeriod, isForever) {
				if (isForever == true) {
					return '永久';
				} else {
					return licensePeriod + '天';
				};
			},
			//硬件锁周期filter
			donglePeriodFilter: function(val) {
				if (val) {
					return val + '天';
				} else {
					return '--';
				};
			},
			//计费方式filter
			chargeModeFilter: function(val) {
				if (val == 1) {
					return '按升级次数';
				} else if (val == 2) {
					return '按锁数量';
				} else {
					return '不限';
				};
			},
			commonFilter: function(val, isTrue) {
				if (isTrue == true) {
					return val;
				} else {
					return '不限';
				};
			},
			//套餐有效期filter
			packagePeriodFilter: function(val) {
				if (val == 2147483647) {
					return '--';
				} else {
					return val + '天';
				};
			},
			//套餐失效日期filter
			expireTimeFilter: function(val) {
				if (!val) {
					return '--';
				} else {
					return val;
				};
			},
			//原因filter
			reasonFilter: function(val) {
				switch(val) {
					case 1:
						return '新购';
						break;
					case 2:
						return '升级';
						break;
					case 3:
						return '续费';
						break;
				};
			},
			//订单状态filter
			statusFilter: function(val) {
				switch(val) {
					case 'paid':
						return '扣款成功';
						break;
					case 'unpaid':
						return '未扣款';
						break;
					case 'faild':
						return '扣款失败';
						break;
					case 'insufficient':
						return '余额不足';
						break;
				};
			},
			//产品分类filter
			categoryNoFilter: function(val) {
				switch(val) {
					case 1:
						return '许可套餐';
						break;
					case 2:
						return '更新次数套餐';
						break;
					case 3:
						return '硬件锁套餐';
						break;
				};
			},
			//并发方式filter
			concurrentFilter: function(hasConcurrent, concurrentType, concurrent) {
				if (hasConcurrent == false) {
					return '单机许可';
				} else {
					var concurrentTypeName = concurrentType=='process'?'进程':'会话';
					return '集团许可 ' + concurrentTypeName + '(用户数: ' + concurrent + ')';
				};
			},
		},
		methods: {
			loadDetailData() {	
				let url = '/order/detail.do';
				let param = {
					orderNo: this.orderNo
				};

				ajax(url, param).then(response => {
					if (response.code == 0) {
						this.orderDetailObj = response.data;
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});					
			},
		},
		mounted() {
			this.orderNo = this.$route.query.orderNo;
			this.loadDetailData();
		},
	}
</script>

<style scoped lang="scss">	

</style>


// WEBPACK FOOTER //
// OrderDetail.vue?06f3bd99